import React from 'react';
import { INotification, NotificationAction } from '../../notifications-interfaces';
import { setNotificationsAction } from '../../data/data-service';
import { IStoreProps } from '../../index';
import { useDispatch } from 'react-redux';

interface INotificationTextProps {
    storeProps: IStoreProps;
    notification: INotification;
}

const NotificationText = ({ storeProps, notification }: INotificationTextProps) => {

    const { rootActions } = storeProps;

    const dispatch = useDispatch();

    const onClick = async () => {

        dispatch(
            rootActions.main({
                additionalOpenedMenuNotification: null,
                additionalOpenedMenuStyles: null,
            })
        );

        await setNotificationsAction(
            notification.userNTFGUID,
            NotificationAction.Click,
        );

        window.location.href = notification.ctaUrl ?? '';
    };

    return (
        <button
            onClick={ onClick }
            type="button"
            className="cursor-pointer text-left">
            <span className="block mb-1">
                { notification.ntfText }
            </span>

            <span className="block text-gray-400">
                { notification.displayDateFormat }
            </span>
        </button>
    )
};

export default NotificationText;